module.exports = __webpack_public_path__ + "static/media/confirmacion_email.fe7fef96.svg";